export const getData = () => fetch("weedlist.json")
  .then(response => response.json())
